(function () {
    'use strict';
    var controllerId = 'operationDetail';
    angular.module('app').controller(controllerId, ['$q', '$state', 'common', 'swaggerService', operationDetail]);

    function operationDetail($q, $state, common, swaggerService) {
        var vm = this;
        vm.swaggerOperation = null;

        activate();
        function activate() {
            common.handleBusyState([getSwaggerOperation()], controllerId);
        }

        //#region Private methods
        function getSwaggerOperation() {
            var deferred = $q.defer();
            if ($state.params && $state.params.apiId && $state.params.operationId) {
                swaggerService.getOperationByApiIdAndOperationId($state.params.apiId, $state.params.operationId).then(function (operation) {
                    vm.swaggerOperation = operation;
                    deferred.resolve(true);
                });
            }
            else
                deferred.resolve(false);

            return deferred.promise;
        }
        //#endregion
    }
})();